const DEFAULT_FETCH_DELAY = 100;

export default class SummaryLoaderItem {
  _source;
  _columnSetting;
  _values;
  _isLoading;
  _lastFetched;
  _lastUpdated;
  _reloadTimer;
  _fetching;
  _error;
  _waitingTimer;
  _staleValue;
  _currentSourceLastUpdated;
  constructor(source, columnSetting) {
    this._source = source;
    this._columnSetting = columnSetting;
    this._values = null;
    this.reset();
  }

  get columnSetting() {
    return this._columnSetting;
  }

  get values() {
    return this._values;
  }

  get source() {
    return this._source;
  }

  get isLoading() {
    return this._isLoading;
  }

  reloadIfNecessaryInternal() {
    const { lastUpdated } = this;

    if (this._lastFetched !== lastUpdated) {
      this._isLoading = true;

      // invoke updater so the graph gets a chance to react to the changing of the load state
      // this lets components to be notified of the start of reloading of the data
      this.source._loadHandler();
      //@ts-ignore
      this.getValue(lastUpdated);
    }
  }

  reloadIfNecessary() {
    const LOAD_DELAY = 100;

    clearTimeout(this._reloadTimer);

    this._reloadTimer = setTimeout(() => {
      this._reloadTimer = null;
      this.reloadIfNecessaryInternal();
    }, LOAD_DELAY);
  }

  getValue(lastUpdated, delay) {
    const handler = () => {
      this._lastFetched = lastUpdated || this.lastUpdated;
      this._isLoading = false;
    };

    return this.fetchValue((err) => {
      if (!err) {
        if (handler) {
          handler();
        }

        this.source._loadHandler();
      } else {
        console.error(err);
      }
    }, delay);
  }

  get lastUpdated() {
    return this._lastUpdated.getTime();
  }

  fetchValue(callback, delay) {
    if (this._error) {
      return null;
    }

    if (this._values) {
      return this._values;
    }

    if (!this._fetching) {
      this._fetching = true;

      this._waitingTimer = setTimeout(() => {
        delete this._waitingTimer;

        this.fetch((fetchError) => {
          delete this._fetching;

          if (fetchError) {
            return callback(fetchError);
          }

          if (callback) {
            /* eslint-disable callback-return */
            callback(null, this);
            /* eslint-enable callback-return */
          }

          return null;
        });
      }, delay || DEFAULT_FETCH_DELAY);
    }

    if (this._staleValue != null) {
      return this._staleValue;
    }

    return null;
  }

  fetch(callback) {
    const sql = this._source.query.toSummarySQL(this.columnSetting);

    const params = { q: sql };

    this.source.dataSource.source.query(params, (err, rows) => {
      if (this.isStaleResponse) {
        return callback(new Error('stale response'));
      }

      if (err) {
        this._error = err;

        return callback(err);
      }

      this._values = rows;

      return callback(null, this);
    });
  }

  reset() {
    this._lastUpdated = new Date();

    this._staleValue = this._values;
    this._values = null;

    this.clearTimers();

    this._error = null;

    // When modifying the query source, we need to invalidate the record pager from
    // processing results. We cancel the timers above, but it's possible that it's too
    // late and the call has already been made and the callback will fire with the results.
    // At some point we can look into cancelling the AJAX requests, but that has other
    // complexities like requiring a handle to the internal request mechanism to even
    // call abort() on.
    // this._currentSourceLastUpdated = this._source.lastUpdated;
  }

  get isStaleResponse() {
    return this._currentSourceLastUpdated != null && (this._currentSourceLastUpdated !== this._source.lastUpdated);
  }

  clearTimers() {
    if (this._waitingTimer) {
      clearTimeout(this._waitingTimer);
    }

    this._fetching = null;
    this._waitingTimer = null;
  }
}
